import React from 'react';
import { BookOpen, Calendar, Clock } from 'lucide-react';

/**
 * Saved Sessions List Component
 * Displays previously saved practice sessions
 */
export default function SavedSessionsList({ sessions, onLoadSession }) {
  
  if (!sessions || sessions?.length === 0) {
    return (
      <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
        <h2 className="text-xl font-bold text-white mb-4">Saved Sessions</h2>
        <div className="bg-white/5 rounded-xl p-6 text-center">
          <BookOpen className="w-8 h-8 text-white/40 mx-auto mb-3" />
          <p className="text-white/60 text-sm">
            No saved sessions yet. Create and save your first practice session!
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20">
      <h2 className="text-xl font-bold text-white mb-4">Saved Sessions</h2>
      
      <div className="space-y-3">
        {sessions?.map((session) => (
          <button
            key={session?.id}
            onClick={() => onLoadSession(session)}
            className="w-full bg-white/5 hover:bg-white/10 rounded-xl p-4 text-left transition-all group"
          >
            <div className="flex items-start justify-between mb-2">
              <h3 className="font-bold text-white group-hover:text-purple-300 transition-colors">
                {session?.name}
              </h3>
              <span className={`px-2 py-1 rounded text-xs font-medium ${
                session?.difficulty === 'beginner' ?'bg-green-500/20 text-green-200'
                  : session?.difficulty === 'intermediate' ?'bg-yellow-500/20 text-yellow-200' :'bg-red-500/20 text-red-200'
              }`}>
                {session?.difficulty}
              </span>
            </div>
            
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div className="flex items-center gap-2 text-white/60">
                <Clock className="w-4 h-4" />
                <span>{session?.duration} min</span>
              </div>
              <div className="flex items-center gap-2 text-white/60">
                <span className="text-yellow-400">⚡</span>
                <span>{session?.estimatedXP} XP</span>
              </div>
            </div>

            {session?.createdAt && (
              <div className="mt-2 flex items-center gap-2 text-xs text-white/40">
                <Calendar className="w-3 h-3" />
                <span>
                  Created {new Date(session?.createdAt)?.toLocaleDateString()}
                </span>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}